export const ROUTE_PATH = '/reconciliations-store';

export const FEATURE_NAME = 'reconciliationStoreToCpPage';
